export default __webpack_public_path__ + "f5c41fa46ef42a49117690ce87822188.png";